import React, { useContext, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import classNames from 'classnames';
import { LessonMode } from '../Constants';
import BuilderLayout from '../assessmentBuilder/layout/BuilderLayout';

// remove manuscript when all components are built and manuscript items are removed from
// preview, graded and review modes
import '../css/AssesmentBuilder.scss';

const AssessmentBuilder = observer(() => {
  const { toolbarManager } = useContext(MobXProviderContext);

  useEffect(() => {
    const className = `${LessonMode.ASSESSMENT_BUILDER} builder-theme-override`;
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('class', className);
  });

  return (
    <>
      <div className={classNames('lesson-window', 'Assessment-Builder', { highlightOn: toolbarManager.isHighlightOrStickyToolOn })}>
        <BuilderLayout />
      </div>
    </>
  );
});
export default AssessmentBuilder;
